import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var Autocomplete = /*#__PURE__*/function () {
  function Autocomplete(context, serviceName, entityType, locale) {
    _classCallCheck(this, Autocomplete);

    this.context = context;
    this.serviceName = serviceName;
    this.entityType = entityType;
    this.locale = locale;
  }

  _createClass(Autocomplete, [{
    key: "search",
    value: function search(text) {
      return this.context.http.get("/msvc/v1/".concat(this.serviceName, "/resolution/autocomplete/").concat(this.entityType), {
        text: text,
        locale: this.locale
      });
    }
  }]);

  return Autocomplete;
}();

export default Autocomplete;